import React, { useContext, useState } from "react";
import { API_URL } from "../components/api";
import { styled, alpha } from "@mui/material/styles";
import AuthContext from "../context/AuthContext";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Axios from "axios";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": { padding: "4px 0" },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:hover": { color: "black" },
    },
  },
}));

export default function CustomizedActions(props) {
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const v = props.subscriptions; // selected subscription IDs

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [Action, setAction] = useState(""); // "Activate" | "Deactivate"
  const [openy, setOpeny] = useState(false);

  const [reason, setReason] = useState("");
  const [message, setMessage] = useState(null);

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleClickOpenpop = () => {
    setReason("");
    setOpeny(true);
  };
  const handleClosepop = () => setOpeny(false);

  const sendAction = (id) => setAction(id);

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 4000);
  };

  const SubmitAction = async () => {
    // Require reason only for Deactivate
    if (Action === "Deactivate" && !reason.trim()) {
      showMessage("Please provide a reason before continuing.", "warning");
      return;
    }

    Axios.post(
      `${API_URL}/radius/subscriptions/iptv/subscriptions/`,
      {
        Action: "Action",
        result: Action,
        sub_id: v,
        userdealer: user.username,
        reason: reason.trim(),
      },
      { headers: { Authorization: `Bearer ${authTokens.access}` } }
    )
      .then((response) => {
        console.log(response.data);
        props?.deselect?.();
        showMessage("Action successful!", "success");
      })
      .catch((error) => {
        console.error(error);
        showMessage("Action failed!", "danger");
      });
  };

  return (
    <div className="test">
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        style={{
          backgroundColor: "transparent",
          height: 32,
          padding: "6px 10px",
        }}
        disableElevation
        onClick={handleClick}
      >
        <i className="fas fa-bolt" style={{ marginRight: 6 }} /> Actions
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Activate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Activate
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            sendAction("Deactivate");
            handleClickOpenpop();
          }}
          disableRipple
        >
          Deactivate
        </MenuItem>
      </StyledMenu>

      <Dialog open={openy} onClose={handleClosepop} fullWidth maxWidth="sm">
        <DialogTitle>
          {Action === "Deactivate"
            ? "Deactivate selected subscriptions?"
            : "Proceed with activation?"}
        </DialogTitle>

        {Action === "Deactivate" && (
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder=""
              sx={{
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "& fieldset": { borderColor: "divider" },
                  "&:hover fieldset": { borderColor: "text.disabled" },
                  "&.Mui-focused fieldset": { borderColor: "primary.main" },
                },
              }}
            />
          </DialogContent>
        )}

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleClosepop} color="inherit">
            No
          </Button>
          <Button
            onClick={() => {
              handleClosepop();
              SubmitAction();
            }}
            autoFocus
            disabled={Action === "Deactivate" && !reason.trim()}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Floating toast */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: 9999,
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}
